import { auth } from "./auth";

export const OWNER_ADMIN_EMAIL = "nicholsglobalbusinessservices@gmail.com";

export const session = {
  getEmail() {
    return auth.getEmail();
  },
  clear() {
    auth.clear();
  },
  isOwnerAdmin(email = null) {
    const value = email || this.getEmail();
    return value?.trim().toLowerCase() === OWNER_ADMIN_EMAIL;
  },
};
